import { Link } from 'gatsby';
import get from 'lodash/get';
import React, { Fragment, useEffect, useState } from 'react';

import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import { FaRssSquare } from "react-icons/fa";
import { ImStackoverflow } from 'react-icons/im';
import { IoIosArrowForward } from 'react-icons/io';
import { SiDevDotTo, SiLeetcode, SiMedium } from 'react-icons/si';
import ReactTooltip from 'react-tooltip';

import profileImgTiny from '../../../images/profile-tiny.jpg';
import profileImg from '../../../images/profile.jpg';
import ThemeToggle from '../../UI/theme-toggler';

const classes = {
  wrapper: 'block mb-4 md:flex',
  imageWrapper: 'w-full max-w-150',
  image:
    'cursor-pointer rounded-full transform transition-all duration-150 hover:scale-105 shadow-3xl border-4 border-gray',
  imageContainerForModal: 'z-10 fixed top-0 left-0 w-full h-screen flex items-center justify-center bg-red',
  imageFromModal:
    'w-96 aspect-square rounded transform transition-all duration-150 shadow-3xl border-4 border-gray',
  contentWrapper: 'flex-none pt-6 md:pt-1 md:flex-1 md:pl-20',
  name:
    'text-4xl sm:text-5xl text-gray-900 dark:text-blue-400 font-bold leading-tight hover:text-black',
  description: 'text-gray-600 dark:text-gray-100 text-lg',
  emailContainer: 'text-gray-600 dark:text-gray-100 py-2 text-md',
  email: 'text-blue-600 dark:text-blue-400 dark:font-semibold',
  list: 'uppercase tracking-wider',
  item: 'inline list-none pr-2 sm:pr-3',
  link:
    'inline-block py-2 font-semibold text-gray-600 text-2xl sm:text-3xl hover:text-gray-800 dark:text-white dark:hover:text-gray-500',
  button: 'font-semibold rounded-md w-fit py-1.5 px-8 mt-1.5 text-white bg-gray-700 dark:text-gray-900 dark:bg-white inline-flex gap-2.5 items-center',
  toggleWrapper: 'mt-5 h-4 md:h-1 text-center',
};

const Header = ({ metadata = {}, noBlog = false }) => {
  const [imageModal, setImageModal] = useState(false)
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [allProfilesListed, setAllProfilesListed] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setTooltipVisible(true);
    }, 500)
  }, []);

  const twitter = get(metadata, 'twitter', false);
  const github = get(metadata, 'github', false);
  const linkedin = get(metadata, 'linkedin', false);
  const devto = get(metadata, 'devto', false);
  const medium = get(metadata, 'medium', false);
  const stackoverflow = get(metadata, 'stackoverflow', false);
  const leetcode = get(metadata, 'leetcode', false);
  const discord = get(metadata, 'discord', false);
  const email = get(metadata, 'email', false);

  // doesn't work on live site
  // useEffect(() => {
  //   // preload bigger profile image for bigger modal view
  //   const handleImagePreload = () => {
  //     const img = new Image();
  //     img.src = profileImg;
  //   }

  //   window.addEventListener('DOMContentLoaded', handleImagePreload)

  //   return () => {
  //     window.removeEventListener('DOMContentLoaded', handleImagePreload)
  //   }
  // }, [])

  return (
    <>
      {imageModal && <div role='button' tabIndex={0} onClick={(e) => { e.target === e.currentTarget && setImageModal(false) }} className={classes.imageContainerForModal} style={{ background: 'rgba(0,0,0,0.5)' }}>
        <img className={classes.imageFromModal} src={profileImg} alt={metadata.name} />
      </div>}
      <div className={classes.wrapper}>
        <div className={classes.imageWrapper}>
          {/* <Link to="/"> */}
          <img onClick={() => setImageModal(true)} className={classes.image} src={profileImgTiny} alt={metadata.name} />
          {/* </Link> */}
          <div className={classes.toggleWrapper}>
            <ThemeToggle />
          </div>
        </div>
        <div className={classes.contentWrapper}>
          <h1 className={classes.name}>
            <Link to="/">{metadata.name}</Link>
          </h1>
          <p className={classes.description}>{metadata.description}</p>
          {email && <>
            <p className={classes.emailContainer}>
              Email at{' '}
              <a href={`mailto:${email}`} target='blank' className={classes.email}>{email}</a>
            </p>
            <hr className='w-2/3 sm:w-1/4' />
          </>}
          <ul className={classes.list}>
            <li className={classes.item}>
              <a className={classes.link} href="https://calendly.com/dev-rhuzaifa/connect" data-tip="Book a meeting"
                data-for="meeting-tooltip">
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"></path></svg>
                {/* <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M960 95.888l-256.224.001V32.113c0-17.68-14.32-32-32-32s-32 14.32-32 32v63.76h-256v-63.76c0-17.68-14.32-32-32-32s-32 14.32-32 32v63.76H64c-35.344 0-64 28.656-64 64v800c0 35.343 28.656 64 64 64h896c35.344 0 64-28.657 64-64v-800c0-35.329-28.656-63.985-64-63.985zm0 863.985H64v-800h255.776v32.24c0 17.679 14.32 32 32 32s32-14.321 32-32v-32.224h256v32.24c0 17.68 14.32 32 32 32s32-14.32 32-32v-32.24H960v799.984zM736 511.888h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32zm0 255.984h64c17.664 0 32-14.32 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.696 14.336 32 32 32zm-192-128h-64c-17.664 0-32 14.336-32 32v64c0 17.68 14.336 32 32 32h64c17.664 0 32-14.32 32-32v-64c0-17.648-14.336-32-32-32zm0-255.984h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.68-14.336-32-32-32zm-256 0h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.68-14.336-32-32-32zm0 255.984h-64c-17.664 0-32 14.336-32 32v64c0 17.68 14.336 32 32 32h64c17.664 0 32-14.32 32-32v-64c0-17.648-14.336-32-32-32z"></path></svg> */}
              </a>
              {tooltipVisible && <ReactTooltip id="meeting-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
            </li>
            {linkedin && (
              <li className={classes.item}>
                <a
                  className={classes.link}
                  href={linkedin}
                  data-tip="LinkedIn Profile"
                  data-for="linkedin-tooltip"
                >
                  <AiFillLinkedin />
                </a>
                {tooltipVisible && <ReactTooltip id="linkedin-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
              </li>
            )}
            {twitter && (
              <li className={classes.item}>
                <a className={classes.link} href={twitter}
                  data-tip="X (Twitter) Profile"
                  data-for="x-tooltip">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
                </a>
                {tooltipVisible && <ReactTooltip id="x-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
              </li>
            )}
            {/* {discord && (
              <li className={classes.item}>
                <a className={classes.link} href={discord} data-tip="Discord Profile"
                  data-for="discord-tooltip">
                  <FaDiscord />
                </a>
                {tooltipVisible && <ReactTooltip id="discord-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
              </li>
            )} */}
            {github && (
              <li className={classes.item}>
                <a className={classes.link} href={github} data-tip="Github Profile"
                  data-for="github-tooltip">
                  <AiFillGithub />
                </a>
                {tooltipVisible && <ReactTooltip id="github-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}

              </li>
            )}
            <li className={classes.item}>
              <a className={classes.link} href="/rss.xml" data-tip="RSS Feed"
                data-for="rss-tooltip">
                <FaRssSquare />
              </a>
              {tooltipVisible && <ReactTooltip id="rss-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
            </li>
            {!allProfilesListed ? <li className={classes.item} onClick={(e) => {
              e.preventDefault()
              setAllProfilesListed(true)
            }}>
              <a className={classes.link} data-tip="More..."
                data-for="more-tooltip">
                <IoIosArrowForward />
              </a>
              {tooltipVisible && <ReactTooltip id="more-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
            </li> :
              <Fragment>
                {stackoverflow && (
                  <li className={classes.item}>
                    <a className={classes.link} href={stackoverflow} data-tip="Stackoverflow Profile"
                      data-for="stackoverflow-tooltip">
                      <ImStackoverflow />
                    </a>
                    {tooltipVisible && <ReactTooltip id="stackoverflow-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
                  </li>
                )}
                {leetcode && (
                  <li className={classes.item}>
                    <a className={classes.link} href={leetcode} data-tip="Leetcode Profile"
                      data-for="leetcode-tooltip">
                      <SiLeetcode />
                    </a>
                    {tooltipVisible && <ReactTooltip id="leetcode-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
                  </li>
                )}
                {medium && (
                  <li className={classes.item}>
                    <a className={classes.link} href={medium} data-tip="Medium Profile"
                      data-for="medium-tooltip">
                      <SiMedium />
                    </a>
                    {tooltipVisible && <ReactTooltip id="medium-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
                  </li>
                )}
                {devto && (
                  <li className={classes.item}>
                    <a className={classes.link} href={devto} data-tip="Dev.to Profile"
                      data-for="devto-tooltip">
                      <SiDevDotTo />
                    </a>
                    {tooltipVisible && <ReactTooltip id="devto-tooltip" place="top" effect="solid" className='custom-tooltip' delayShow={0} delayHide={0} />}
                  </li>
                )}
              </Fragment>}
          </ul>
          {!noBlog && (
            <Link className={classes.button} to="/blog">
              {/* <RiPencilFill /> */}
              Blogs
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
